import currentPos from "./currentPos@3x.png";

export default currentPos;
